module.exports = __webpack_public_path__ + "img/icon32-quality.5123ca51.svg";